import React from "react";

const QUALIFIER = "Synthetic example, not project findings.";
const routes = [
  { key: "a", heading: "Land continuity", reasons: ["Fewer difficult crossings", "Modest extra distance"] },
  { key: "b", heading: "Shorter alignment", reasons: ["Additional road crossing", "More separate land interests"] },
  { key: "c", heading: "More constraints", reasons: ["Complex rail crossing", "Unresolved title and tighter workspace"] },
];

export const PathScoreRoutes = () => (
  <figure className="ps__schematic" data-testid="pathscore-route-schematic" aria-labelledby="pathscore-schematic-caption">
    <figcaption id="pathscore-schematic-caption" data-testid="pathscore-schematic-qualifier">{QUALIFIER}</figcaption>
    <div className="ps__diagram-endpoints" aria-hidden="true"><span>Shared start</span><span>Shared end</span></div>
    <svg viewBox="0 0 640 270" role="img" aria-labelledby="pathscore-diagram-title pathscore-diagram-description" data-testid="pathscore-route-diagram">
      <title id="pathscore-diagram-title">Synthetic A, B and C corridor refinement</title>
      <desc id="pathscore-diagram-description">Synthetic alternatives share endpoints; their positions do not prescribe routing. Dashed lines are before review and solid lines refined. No client or project geometry is represented.</desc>
      <g fill="none" stroke="#85878C" strokeWidth="2" strokeDasharray="7 7">
        <path d="M42 135 L180 105 L400 155 L598 135" />
        <path d="M42 135 L170 75 L430 80 L598 135" />
        <path d="M42 135 L170 205 L430 200 L598 135" />
      </g>
      <g fill="none" strokeWidth="4" strokeLinejoin="round">
        <path d="M42 135 L170 135 L235 118 L395 118 L455 135 L598 135" stroke="#C8102E" />
        <path d="M42 135 L155 46 L440 46 L520 88 L598 135" stroke="#F5F2EC" />
        <path d="M42 135 L160 222 L425 222 L505 180 L598 135" stroke="#B8BFCB" />
      </g>
      <g fill="#F5F2EC" fontSize="28" fontWeight="700" textAnchor="middle">
        <text x="320" y="102">A</text><text x="320" y="32">B</text><text x="320" y="256">C</text>
      </g>
      <g fill="#F5F2EC" stroke="#090A0C" strokeWidth="3"><circle cx="42" cy="135" r="9" /><circle cx="598" cy="135" r="9" /></g>
    </svg>
    <div className="ps__diagram-legend" data-testid="pathscore-diagram-legend"><span><i className="ps__line ps__line--before" />Before review</span><span><i className="ps__line" />Refined</span></div>
    <p className="ps__small">Illustrative positions only; routes follow project constraints.</p>
  </figure>
);

export const PathScoreComparison = () => (
  <figure data-testid="pathscore-score-comparison" aria-labelledby="pathscore-schematic-caption">
    <div className="ps__cards" data-testid="pathscore-routes-grid">
      {routes.map((route) => <article key={route.key} className="ps__card ps__score-card" data-testid={`pathscore-route-${route.key}`}>
        <h3>Route {route.key.toUpperCase()}</h3>
        <p className="ps__score-heading" data-testid={`pathscore-route-${route.key}-recommendation`}>{route.heading}</p>
        <ul data-testid={`pathscore-route-${route.key}-reasons`}>{route.reasons.map(reason => <li key={reason}>{reason}</li>)}</ul>
      </article>)}
    </div>
  </figure>
);